export default "__VITE_ASSET__BuysLEVs__"